import { EventFieldVisibleRequiredEnum } from '../shared/event-field-visible-required.enum';
//import * as moment from 'moment-es6';
import { MomentService } from '../../shared/moment/moment.service';
import { Injectable } from "@angular/core";

@Injectable()
export class EventNewParams {
  public EventName: string;
  public StartDate: Date;
  public StartTime: string;
  public EndDate: Date;
  public EndTime: string;
  public OrgEvent: boolean = true;
  public Email: string;

  public RegEmailVisible: number = EventFieldVisibleRequiredEnum.BothRegistrationAndAttendee;
  public RegEmailRequired: number = EventFieldVisibleRequiredEnum.RegistrationOnly;
  public RegPrefixVisible: number;
  public RegPrefixRequired: number;
  public RegFNameVisible: number = EventFieldVisibleRequiredEnum.BothRegistrationAndAttendee;
  public RegFNameRequired: number = EventFieldVisibleRequiredEnum.RegistrationOnly;
  public RegLNameVisible: number = EventFieldVisibleRequiredEnum.BothRegistrationAndAttendee;
  public RegLNameRequired: number = EventFieldVisibleRequiredEnum.RegistrationOnly;
  public RegNameForBadgeVisible: number;
  public RegNameForBadgeRequired: number;
  public RegCompanyNameVisible: number = EventFieldVisibleRequiredEnum.BothRegistrationAndAttendee;
  public RegCompanyNameRequired: number = EventFieldVisibleRequiredEnum.RegistrationOnly;
  public RegAddressVisible: number = EventFieldVisibleRequiredEnum.RegistrationOnly;
  public RegAddressRequired: number;
  public RegPhoneVisible: number = EventFieldVisibleRequiredEnum.RegistrationOnly;
  public RegPhoneRequired: number;
  public RegMobileVisible: number;
  public RegMobileRequired: number;
  public ShowWeatherLink: boolean;
  public AttendeeGoal: number;
  public SalesGoal: number;
  public RegTitleVisible: number = EventFieldVisibleRequiredEnum.BothRegistrationAndAttendee;
  public RegTitleRequired: number;
  public SourceUtcOffSetMinutes: number;

  private _momentService: MomentService;

  public constructor() {
    let now: Date = new Date();
    this._momentService = new MomentService();
    this._momentService.getMomentByDate(now);

    //this.EventName = "";
    //this.StartDate = moment.Moment(new Date(now.getFullYear(), now.getMonth(), now.getDate())).add(1, "d").toDate();
    //this.StartTime = "";
    //this.EndDate = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate())).add(1, "d").toDate();
    //this.EndTime = "";
    this.EventName = '';
    this.StartDate = this._momentService
      .getMomentByDate(now)
      .add(1, 'd')
      .toDate();
    this.StartTime = '';
    this.EndDate = this._momentService
      .getMomentByDate(now)
      .add(1, 'd')
      .toDate();
    this.EndTime = '';

    this.SourceUtcOffSetMinutes = 0;
  }
}
